import { number, shape, string } from 'prop-types'

export const ReviewsSummary_v1 = shape({
  averageRating: number,
  language: string,
  ratingCount: number,
  starsFive: number,
  starsFour: number,
  starsOne: number,
  starsThree: number,
  starsTwo: number,
  variant_code: string,
})
